import React from 'react'
import './AthleteExtras.css'
import '../layout/Spinner.css'

const AthleteExtras = (props) => {

        const athleteExtras = props.athleteExtras

        var displayExtras = null
        var extras = null
        var strengths = null
        var hobbies = null

        var extrasExist = false
        var strengthsExist = false
        var hobbiesExist = false

        if (athleteExtras) {

            if (athleteExtras.extraOne && athleteExtras.extraOne !== 'None') {

                extrasExist = true

                extras = [
                    <div className="AthleteExtrasRow" key='extraOne'>
                        <p>{athleteExtras.extraOne}</p>
                    </div>
                ]   
            }
            if (athleteExtras.extraTwo && athleteExtras.extraTwo !== 'None') {

                extrasExist = true

                extras = [
                    extras,
                    <div className="AthleteExtrasRow" key='extraTwo'>
                        <p>{athleteExtras.extraTwo}</p>
                    </div>
                ]   
            }
            if (athleteExtras.extraThree && athleteExtras.extraThree !== 'None') {

                extrasExist = true

                extras = [
                    extras,
                    <div className="AthleteExtrasRow" key='extraThree'>
                        <p>{athleteExtras.extraThree}</p>
                    </div>
                ]   
            }
            if (athleteExtras.extraFour && athleteExtras.extraFour !== 'None') {

                extrasExist = true

                extras = [
                    extras,
                    <div className="AthleteExtrasRow" key='extraFour'>
                        <p>{athleteExtras.extraFour}</p>
                    </div>
                ]   
            }
            if (athleteExtras.extraFive && athleteExtras.extraFive !== 'None') {

                extrasExist = true

                extras = [
                    extras,
                    <div className="AthleteExtrasRow" key='extraFive'>
                        <p>{athleteExtras.extraFive}</p>
                    </div>
                ]   
            }
            if (athleteExtras.strengthOne && athleteExtras.strengthOne !== 'None') {

                strengthsExist = true

                strengths = [
                    <div className="AthleteExtrasRow" key='strengthOne'>
                        <p>{athleteExtras.strengthOne}</p>
                    </div>
                ]   
            }
            if (athleteExtras.strengthTwo && athleteExtras.strengthTwo !== 'None') {

                strengthsExist = true

                strengths = [
                    strengths,
                    <div className="AthleteExtrasRow" key='strengthTwo'>
                        <p>{athleteExtras.strengthTwo}</p>
                    </div>
                ]   
            }
            if (athleteExtras.strengthThree && athleteExtras.strengthThree !== 'None') {

                strengthsExist = true

                strengths = [
                    strengths,
                    <div className="AthleteExtrasRow" key='strengthThree'>
                        <p>{athleteExtras.strengthThree}</p>
                    </div>
                ]   
            }
            if (athleteExtras.strengthFour && athleteExtras.strengthFour !== 'None') {

                strengthsExist = true

                strengths = [
                    strengths,
                    <div className="AthleteExtrasRow" key='strengthFour'>
                        <p>{athleteExtras.strengthFour}</p>
                    </div>
                ]   
            }
            if (athleteExtras.strengthFive && athleteExtras.strengthFive !== 'None') {

                strengthsExist = true

                strengths = [
                    strengths,
                    <div className="AthleteExtrasRow" key='strengthFive'>
                        <p>{athleteExtras.strengthFive}</p>
                    </div>
                ]   
            }
            if (athleteExtras.hobbyOne && athleteExtras.hobbyOne !== 'None') {

                hobbiesExist = true

                hobbies = [
                    <div className="AthleteExtrasRow" key='hobbyOne'>
                        <p>{athleteExtras.hobbyOne}</p>
                    </div>
                ]   
            }
            if (athleteExtras.hobbyTwo && athleteExtras.hobbyTwo !== 'None') {

                hobbiesExist = true

                hobbies = [
                    hobbies,
                    <div className="AthleteExtrasRow" key='hobbyTwo'>
                        <p>{athleteExtras.hobbyTwo}</p>
                    </div>
                ]   
            }
            if (athleteExtras.hobbyThree && athleteExtras.hobbyThree !== 'None') {

                hobbiesExist = true

                hobbies = [
                    hobbies,
                    <div className="AthleteExtrasRow" key='hobbyThree'>
                        <p>{athleteExtras.hobbyThree}</p>
                    </div>
                ]   
            }
            if (athleteExtras.hobbyFour && athleteExtras.hobbyFour !== 'None') {

                hobbiesExist = true

                hobbies = [
                    hobbies,
                    <div className="AthleteExtrasRow" key='hobbyFour'>
                        <p>{athleteExtras.hobbyFour}</p>
                    </div>
                ]   
            }
            if (athleteExtras.hobbyFive && athleteExtras.hobbyFive !== 'None') {

                hobbiesExist = true

                hobbies = [
                    hobbies,
                    <div className="AthleteExtrasRow" key='hobbyFive'>
                        <p>{athleteExtras.hobbyFive}</p>
                    </div>
                ]   
            }

            // if (extrasExist && strengthsExist && hobbiesExist) {

                displayExtras = (
                    <div className="AthleteExtrasInfoWrapperContainer">
                        <div className="AthleteExtrasInfoContainer">
                            {strengthsExist && (<div className="AthleteExtrasGroupContainer">
                                <h3>Athletic Strengths</h3>
                                {strengths}
                            </div>)}
                            
                            {extrasExist && (<div className="AthleteExtrasGroupContainer">
                                <h3>Extracurricular</h3>
                                {extras}
                            </div>)}
                            
                        </div>
                        {hobbiesExist && ( <div className="AthleteExtrasInfoContainer">
                            <div className="AthleteExtrasGroupContainer">
                                <h3>Hobbies</h3>
                                {hobbies}
                            </div>
                        </div>)}
                       
                    </div>
                )
            // } else {
            //     displayExtras = null
            // }
        }

        return displayExtras
}

export default AthleteExtras